import { render } from "./codeLogin.vue?vue&type=template&id=f16cb198&scoped=true"
import script from "./codeLogin.vue?vue&type=script&lang=js"
export * from "./codeLogin.vue?vue&type=script&lang=js"

import "./codeLogin.vue?vue&type=style&index=0&id=f16cb198&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16cb198"]])

export default __exports__